import React from 'react'

import { AsyncSelect, Form, Col, Row } from '_zari/core'

import { AdminContext } from 'contexts/AdminContext'
import { ZariContext } from '_zari/context'

import * as ProductosCrud from 'services/producto.service'

const FilaBusquedaTemplate = ({
  esFilaActiva,
  seleccionarProductoViaBusquedaHandler,
  seleccionarProductoViaCodigoBarraHandler
}) => {
  const __adminContext = React.useContext(AdminContext)
  const __zariContext = React.useContext(ZariContext)

  const [codigoBarra, setCodigoBarra] = React.useState('')

  const loadProductosSelect = (inputValue, resolve) => {
    ProductosCrud.obtenerAsInventariosSelect2({
      busqueda: inputValue,
      tipo: '1'
    }).then(({ data }) => resolve(data))
  }

  const keyUpCodigoBarraHandler = e => {
    const keyCode = e.keyCode
    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()
      if (codigoBarra === '') {
        __zariContext.snack('error', 'Ingresar código de barra.')
        return
      }

      ProductosCrud.getProducto_Ventas_CodigoBarras(codigoBarra)
        .then(({ data }) => {
          if (data) {
            seleccionarProductoViaCodigoBarraHandler(data)
          } else {
            throw Error('')
          }
        })
        .catch(() => {
          __zariContext.snack('error', 'El código de barra no existe.')
          setCodigoBarra('')
        })
    }
  }

  const keyDownCodigoBarraHandler = e => {
    const keyCode = e.keyCode
    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()
    }
  }

  return (
    <Row style={{ marginBottom: '3.5rem' }}>
      {__adminContext.valoresConfiguracionCompania.flagCodigoBarra && (
        <Col md={1}>
          <Form.InputText
            placeholder='Cod barra'
            value={codigoBarra}
            onChange={e => setCodigoBarra(e.target.value)}
            onKeyUp={keyUpCodigoBarraHandler}
            onKeyDown={keyDownCodigoBarraHandler}
            autoFocus={esFilaActiva}
          />
        </Col>
      )}
      <Col md={__adminContext.valoresConfiguracionCompania.flagCodigoBarra ? 11 : 12}>
        <AsyncSelect
          selectId='productoSelect'
          loadOptions={loadProductosSelect}
          onChange={seleccionarProductoViaBusquedaHandler}
          defaultMenuIsOpen={esFilaActiva && !__adminContext.valoresConfiguracionCompania.flagCodigoBarra}
          autoFocus={esFilaActiva && !__adminContext.valoresConfiguracionCompania.flagCodigoBarra}
        />
      </Col>
    </Row>
  )
}

export default React.memo(FilaBusquedaTemplate)
